// @flow
import React from 'react';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import commentReply from 'app/redux/actions/commentReply';
import Grid from '@material-ui/core/Grid';
import api from 'utils/API';
import {scrollTo} from 'utils/Helper';
import {set as setCurrentUser, get as getCurrentUser} from 'utils/CurrentUser';
// import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import Input from 'app/components/Input';
import styles from './PostCommentForm.styles.js';

type Props = {
  classes: any,
  postId: number,
  commentReply: any,
};

type State = {
  list: Array,
  hints: abny,
  // form data
  author: String,
  author_email: String,
  content: String,
  parent_id: Number,
  captcha: String,
  post_id: Number
};

class PostCommentForm extends React.Component<Props, State> {

  FORM_INIT_DATA = {
    author: '',
    author_email: '',
    content: '',
    parent_id: null,
    captcha: '',
    post_id: null
  };

  constructor(props) {
    super(props);

    this.state = {
      list: [],
      hints: {}
    };
  }

  send = () => {
    // empty prev hints
    this.setState({hints: {}});

    const url = '/comments/send';
    const data = {
      author: this.state.author || '',
      author_email: this.state.author_email || '',
      content: this.state.content || '',
      parent_id: this.props.commentReply.commentId || '',
      captcha: '',
      post_id: this.props.postId || '',
    };

    api.post(url, data)
    .then(response => {
      if (response.status !== 200) {
        return;
      }

      const data = response.data;
      if (data.result === 'success') {
        // Save user's info (name & email) from later user confident
        setCurrentUser({
          name: this.state.author,
          email: this.state.author_email
        });
        //
        // reset form data & messages
        this.setState({
          messages: data.form_flashes,
          content: this.FORM_INIT_DATA.content
        });
        //
        // reset comment reply position and indicator
        this.props.dispatch(commentReply.cancel());
        //
      } else if (data.result === 'errors') {
        this.setState({hints: data.field_errors});
      }
    });
  }

  scrollToReply = () => {
    scrollTo(`.post-comment-${this.props.commentReply.commentId}`);
    // scroll(`.post-comment-${this.props.commentReply.commentId}`);
  }

  replyCancel = () => {
    this.props.dispatch(commentReply.cancel());
  }

  handleInput = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  componentDidMount() {
    const userData = getCurrentUser();
    this.setState({
      author: userData.name,
      author_email: userData.email,
    });
  }

  render() {
    const {classes, commentReply} = this.props;

    return (
      <div className="post-comment-form">
        <div className={classes.titleLine}>
          <h3 className={classes.title}>
            <span className={classes.iconMessage}></span>نوشتن دیدگاه
          </h3>
        </div>
        {commentReply.commentId &&
          <div className={classes.replyTo}>
            <span>در پاسخ به دیدگاه</span> 
            <span className={classes.replyTarget} onClick={this.scrollToReply}>
              «{commentReply.authorName}»
            </span> -
            <span className={classes.replyCancel} onClick={this.replyCancel}>
              لغو
            </span>
          </div>
        }

        <form>
          <ul className={classes.messages}>
            {this.state.messages &&
              this.state.messages.map((item, index) => <li key={index}>{item.msg}</li>)}
          </ul>
          <Grid container>
            <Grid item xs={12} md={5}>
              <Input
                fullWidth
                placeholder={'نام'}
                onChange={this.handleInput}
                value={this.state.author}
                className={{root: classes.inputRoot, input: classes.input}}
                name="author"
                icon="user2"
                spacing={16}
                hints={this.state.hints.author}
              />
              <Input
                fullWidth
                placeholder={'ایمیل'}
                onChange={this.handleInput}
                value={this.state.author_email}
                className={{root: classes.inputRoot, input: classes.input}}
                name="author_email"
                icon="markunread"
                spacing={16}
                hints={this.state.hints.author_email}
              />
            </Grid>
            <Grid item xs={12} md={7}>
              <Input
                fullWidth
                type="textarea"
                placeholder={'دیدگاه شما'}
                onChange={this.handleInput}
                value={this.state.content}
                className={{root: classes.messageRoot, input: classes.message}}
                name="content"
                icon="chat_bubble"
                hints={this.state.hints.content}
              />
            </Grid>
            <Grid item xs={12} md={12} className={classes.sendButtonWrapper}>
              <Input
                type="button"
                text="ارسال"
                icon="send"
                onClick={this.send}
                className={{input: classes.sendButton, root: classes.sendButtonFormControl}}
              />
            </Grid>
          </Grid>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  permissions: state.permissions,
  commentReply: state.commentReply
});

const Component = connect(mapStateToProps)(withStyles(styles)(PostCommentForm));
export {Component as PostCommentForm};
export default Component;